import { FUEL_TYPE_DATA, MOTORIZACION } from '../constants/carline-constants';
import { configProviderManager } from '../service/config-provider';
import { OkapiMediaAsset } from '../types/vehicle-types';

export const getBrand = (): string | undefined => {
	return configProviderManager.getBrand() ?? undefined;
};

// Convierte el array de mediaAssets de Okapi en un objeto indexado por mpsId (solo type URL).
export const mapOkapiMediaAssets = (mediaAssets?: OkapiMediaAsset[]): Record<string, string> =>
	(mediaAssets ?? []).reduce<Record<string, string>>((acc, { mpsId, asset, type }) => {
		if (mpsId && asset && type === 'URL') {
			acc[mpsId] = asset;
		}
		return acc;
	}, {});

export const isComerciales = (): boolean => {
	return getBrand() === 'N';
};

const ETIQUETA_ORDER = ['0', 'ECO', 'C'];

export const getEtiquetasDgt = (etiquetas: (string | null | undefined)[]): string[] =>
	[...etiquetas]
		.filter((etiqueta): etiqueta is string => Boolean(etiqueta))
		.sort((a, b) => ETIQUETA_ORDER.indexOf(a) - ETIQUETA_ORDER.indexOf(b))
		.map(getEtiquetaDgt)
		.filter((etiqueta): etiqueta is string => Boolean(etiqueta));

export const getEtiquetaDgt = (etiqueta?: string | null): string | undefined => {
	const etiquetaC = 'https://cdn.volkswagen.es/repository/app/vw-match/assets/icon/stock_etiqueta_c.png';
	const etiquetaEco = 'https://cdn.volkswagen.es/repository/app/vw-match/assets/icon/stock_etiqueta_eco.png';
	const etiquetaZero = 'https://cdn.volkswagen.es/repository/app/vw-match/assets/icon/stock_etiqueta_0.png';

	switch (etiqueta) {
		case 'C':
			return etiquetaC;
		case '0':
			return etiquetaZero;
		case 'ECO':
			return etiquetaEco;
		default:
			return undefined;
	}
};

export const normalizeFuelTypeText = (fuelType: string): FUEL_TYPE_DATA | string => {
	if (fuelType == 'H\u00edbrido enchufable' || fuelType == 'Híbrido enchufable') {
		return FUEL_TYPE_DATA.HIBRIDO_ENCHUFABLE;
	} else if (fuelType == 'H\u00edbrido' || fuelType == 'Híbrido') {
		return FUEL_TYPE_DATA.HIBRIDO;
	} else if (fuelType == 'Gasolina mild Hybrid') {
		return FUEL_TYPE_DATA.MILD_HYBRID;
	} else if (fuelType == 'Gasolina') {
		return FUEL_TYPE_DATA.GASOLINA;
	} else if (fuelType == 'El\u00e9ctrico' || fuelType == 'Eléctrico') {
		return FUEL_TYPE_DATA.ELECTRICO;
	} else if (fuelType == 'Di\u00e9sel' || fuelType == 'Diésel') {
		return FUEL_TYPE_DATA.DIESEL;
	} else {
		return fuelType;
	}
};

export const getMotorizacionFromFuelType = (combustible: string): MOTORIZACION | null => {
	switch (normalizeFuelTypeText(combustible)) {
		case FUEL_TYPE_DATA.GASOLINA:
		case FUEL_TYPE_DATA.DIESEL:
		case FUEL_TYPE_DATA.MILD_HYBRID:
		case FUEL_TYPE_DATA.HIBRIDO:
			return MOTORIZACION.COMBUSTION;

		case FUEL_TYPE_DATA.HIBRIDO_ENCHUFABLE:
			return MOTORIZACION.HIBRIDO_ENCHUFABLE;

		case FUEL_TYPE_DATA.ELECTRICO:
			return MOTORIZACION.ELECTRICO;

		default:
			return null;
	}
};
export const getFuelTypesForMotorizacion = (
	vehicle: { combustibles?: string[] },
	motorizacion: MOTORIZACION,
): string[] =>
	(vehicle.combustibles ?? []).filter((combustible) => getMotorizacionFromFuelType(combustible) === motorizacion);

export const getEtiquetaDgtCodeFromFuelType = (fuelType: FUEL_TYPE_DATA | string): string | undefined => {
	switch (normalizeFuelTypeText(fuelType)) {
		case FUEL_TYPE_DATA.GASOLINA:
		case FUEL_TYPE_DATA.DIESEL:
			return 'C';

		case FUEL_TYPE_DATA.MILD_HYBRID:
		case FUEL_TYPE_DATA.HIBRIDO:
			return 'ECO';

		case FUEL_TYPE_DATA.HIBRIDO_ENCHUFABLE:
		case FUEL_TYPE_DATA.ELECTRICO:
			return '0';

		default:
			return undefined;
	}
};
export const getEtiquetaDgtFromFuelType = (fuelType: FUEL_TYPE_DATA | string) => {
	const etiqueta = getEtiquetaDgtCodeFromFuelType(fuelType);
	return etiqueta ? getEtiquetaDgt(etiqueta) : undefined;
};
